import { UAParser } from 'ua-parser-js';
import { detectPlatform } from '../context/messengerContext';

export const getUserAgentParser = () => {
    const userAgent = navigator.userAgent;
    const parser = new UAParser(userAgent);
    return parser;
};

export const isIOSVersionHigherThan26Version = () => {
    const parser = getUserAgentParser()?.getOS();

    const platform = detectPlatform();

    const versionSlice = navigator?.userAgent?.split('Version/')?.[1];
    const userAgentVersion = versionSlice?.split('.')?.[0];

    // Проверяем, является ли пользователь Telegram-клиентом и является ли его iOS версия выше 26
    const isTelegram = platform === 'telegram';

    const isIos26Version =
        parser?.name === 'iOS' &&
        (parser?.version > '18.6' || userAgentVersion > '18.6');

    return isTelegram && isIos26Version;
};
